export default __webpack_public_path__ + "static/maax-medium-webfont-880b68669d1a7d089574113b89264762.woff";